import WebPageIcon from './WebPageIcon'

export default WebPageIcon